// Shared looping hero controls for the storefront and native Shopify theme.
export function mountHero(root, count, onSelect) {
  const events = new AbortController(), options = {signal:events.signal};
  let index = 0, timer, drag = null, suppressClick = false;
  let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pause = root.querySelector('[data-hero-pause]');
  const syncPause = () => {
    if (!pause) return;
    pause.textContent = paused ? 'Play' : 'Pause';
    pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
    pause.setAttribute('aria-pressed', String(paused));
    pause.hidden = count < 2;
  };
  const stop = () => clearTimeout(timer);
  const schedule = () => {
    stop();
    if (count > 1 && !paused && !document.hidden && !drag) timer = setTimeout(() => show(index + 1), 5000);
  };
  const show = next => {
    index = (next + count) % count;
    root.dataset.activeSlide = String(index);
    onSelect(index);
    root.querySelectorAll('[data-slide-to]').forEach(button => {
      const active = Number(button.dataset.slideTo) === index;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    schedule();
  };
  root.addEventListener('click', event => {
    if (suppressClick) {event.preventDefault();event.stopPropagation();suppressClick = false;return;}
    const button = event.target.closest('[data-slide-to],[data-hero-pause]');
    if (!button) return;
    if (button.hasAttribute('data-hero-pause')) {paused = !paused; syncPause(); schedule();}
    else show(Number(button.dataset.slideTo));
  }, {...options, capture:true});
  root.addEventListener('dragstart', event => event.preventDefault(), options);
  root.addEventListener('pointerdown', event => {
    if (count < 2 || event.isPrimary === false || event.button !== 0 || event.target.closest('button,input,select,textarea')) return;
    suppressClick = false;
    drag = {id:event.pointerId,x:event.clientX,y:event.clientY,dx:0,horizontal:false};
    stop();
  }, options);
  root.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    drag.dx = event.clientX - drag.x;
    const dy = event.clientY - drag.y;
    if (!drag.horizontal && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(drag.dx)) {drag = null; schedule();return;}
    if (!drag.horizontal && Math.abs(drag.dx) > 12 && Math.abs(drag.dx) > Math.abs(dy)) {
      drag.horizontal = true;
      root.setPointerCapture(event.pointerId);
    }
    if (drag.horizontal) event.preventDefault();
  }, options);
  const end = event => {
    if (!drag || event.pointerId !== drag.id) return;
    const previous = drag; drag = null;
    if (root.hasPointerCapture(event.pointerId)) root.releasePointerCapture(event.pointerId);
    suppressClick = previous.horizontal;
    if (event.type === 'pointerup' && previous.horizontal && Math.abs(previous.dx) >= 45) show(index + (previous.dx < 0 ? 1 : -1));
    else schedule();
  };
  root.addEventListener('pointerup', end, options);
  root.addEventListener('pointercancel', end, options);
  root.addEventListener('lostpointercapture', () => {if(drag){drag = null;schedule();}}, options);
  document.addEventListener('visibilitychange', schedule, options);
  syncPause(); show(0);
  return () => {stop();events.abort();};
}
const native = new WeakMap();
function startNative(container) {
  container.querySelectorAll('[data-hero]').forEach(root => {
    if (native.has(root)) return;
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    if (slides.length) native.set(root, mountHero(root, slides.length, index => slides.forEach((slide,i) => {slide.hidden = i !== index;})));
  });
}
startNative(document);
document.addEventListener('shopify:section:load', event => startNative(event.target));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-hero]').forEach(root => {native.get(root)?.();native.delete(root);}));
